import { Box, Button, Flex } from '@chakra-ui/react';
import React, { useState } from 'react';
import { LuEye, LuEyeOff } from 'react-icons/lu';

import config from 'configs/app';
import { SocketProvider } from 'lib/socket/context';
import { Checkbox } from 'toolkit/chakra/checkbox';
import { Heading } from 'toolkit/chakra/heading';
import AdaptiveTabs from 'toolkit/components/AdaptiveTabs/AdaptiveTabs';
import LatestOptimisticDeposits from 'ui/home/latestDeposits/LatestOptimisticDeposits';
import LatestTxs from 'ui/home/LatestTxs';
import LatestWatchlistTxs from 'ui/home/LatestWatchlistTxs';
import LatestZetaChainCCTXs from 'ui/home/latestZetaChainCCTX/LatestZetaChainCCTXs';
import useAuth from 'ui/snippets/auth/useIsAuth';

import LatestArbitrumDeposits from './latestDeposits/LatestArbitrumDeposits';

const rollupFeature = config.features.rollup;
const zetachainFeature = config.features.zetachain;

const Transactions = () => {
  const isAuth = useAuth();
  const [ filter, setFilter ] = useState<'all' | 'manual'>('all');

  if ((rollupFeature.isEnabled && (rollupFeature.type === 'optimistic' || rollupFeature.type === 'arbitrum')) || isAuth || zetachainFeature.isEnabled) {
    const tabs = [
      zetachainFeature.isEnabled && {
        id: 'cctx',
        title: 'Cross-chain',
        component: (
          <SocketProvider url={ config.apis.zetachain?.socketEndpoint } name="zetachain">
            <LatestZetaChainCCTXs/>
          </SocketProvider>
        ),
      },
      { id: 'txn', title: zetachainFeature.isEnabled ? 'ZetaChain EVM' : 'Latest txn', component: <LatestTxs filter={ filter }/> },
      rollupFeature.isEnabled && rollupFeature.type === 'optimistic' &&
      { id: 'deposits', title: 'Deposits (L1→L2 txn)', component: <LatestOptimisticDeposits/> },
      rollupFeature.isEnabled && rollupFeature.type === 'arbitrum' &&
      { id: 'deposits', title: 'Deposits (L1→L2 txn)', component: <LatestArbitrumDeposits/> },
      isAuth && { id: 'watchlist', title: 'Watch list', component: <LatestWatchlistTxs/> },
    ].filter(Boolean);
    return (
      <Box
        bg="rgba(255, 255, 255, 0.02)"
        borderRadius="xl"
        p={ 5 }
        boxShadow="0 4px 20px rgba(0, 0, 0, 0.2)"
        border="1px solid"
        borderColor="whiteAlpha.100"
      >
        <Flex justifyContent="space-between" alignItems="center" mb={ 3 }>
          <Heading level="3">Transactions</Heading>
          <Button
            size="xs"
            variant="ghost"
            onClick={ () => setFilter(filter === 'all' ? 'manual' : 'all') }
            colorScheme="blue"
            _hover={{ bg: 'whiteAlpha.200' }}
          >
            { filter === 'manual' ? <LuEyeOff style={{ marginRight: '4px' }}/> : <LuEye style={{ marginRight: '4px' }}/> }
            { filter === 'manual' ? 'Show Hidden' : 'Hide System' }
          </Button>
        </Flex>
        <AdaptiveTabs tabs={ tabs } unmountOnExit={ false } listProps={{ mb: 3 }}/>
      </Box>
    );
  }

  return (
    <Box
      bg="rgba(255, 255, 255, 0.02)"
      borderRadius="xl"
      p={ 5 }
      boxShadow="0 4px 20px rgba(0, 0, 0, 0.2)"
      border="1px solid"
      borderColor="whiteAlpha.100"
    >
      <div style={{ display: 'flex', gap: '16px', justifyContent: 'space-between' }}>
        <Heading
          as="button"
          level="3"
          mb={ 3 }
          style={{
            cursor: 'pointer',
            color: filter === 'all' ? '#3182ce' : undefined,
            background: 'none',
            border: 'none',
            padding: 0,
          }}
          onClick={ () => setFilter('all') }
        >

          { filter === 'manual' ? 'Transactions' : 'Latest transactions' }
        </Heading>
        { /* <Heading
          as="button"
          level="3"
          mb={3}
          style={{
            cursor: 'pointer',
            color: filter === 'manual' ? '#3182ce' : undefined,
            background: 'none',
            border: 'none',
            padding: 0,
          }}
          onClick={() => setFilter('manual')}
        >
          Manual transactions
        </Heading> */ }
        <Checkbox
          size="sm"
          mb={ 3 }
          checked={ filter === 'manual' }
          onCheckedChange={ ({ checked }) =>
            setFilter(checked ? 'manual' : 'all')
          }
        >
          Hide details
        </Checkbox>

      </div>

      <LatestTxs filter={ filter }/>
    </Box >
  );
};

export default Transactions;
